exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".business-number-cell[data-v-5cc23725] {\n  width: 200px;\n}\n.card-icon-text[data-v-5cc23725] {\n  color: white;\n}\n.md-theme-default a[data-v-5cc23725]:not(.md-button) {\n  color: black;\n}\n", ""]);

// exports
